import React, { useEffect } from "react";
import Sidebar from "src/components/common/Sidebar";
import RodeoEventGamePage from "src/components/events/rodeoEventGame/rodeoEventGamePage";
import { APPLICATION_NAME, RODEO_PAGE_NAME } from "src/_config";

export default function RodeoEventGameContainer() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${APPLICATION_NAME} : Event List`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <React.Fragment>
      <section className="main-container">
        <Sidebar page={RODEO_PAGE_NAME.EVENT_GAME_LIST} />
        <RodeoEventGamePage />
      </section>
    </React.Fragment>
  );
}
